import { IStore } from '../index'

export const getClientContactPersons = (state: IStore, clientId?: string) =>
  clientId ? state.clientContactPersonsReducer[clientId] : []
